<template>

	<div class="autops">
		<el-row :gutter="20" style="width: 100%;    margin-left: -0px;    margin-right: -10px;">
			<el-col :span="11" style="padding:0;">
				<el-table border stripe :data="selectiondata" header-row-class-name="table-header" fit>
					<el-table-column type="selection" width="40" align="center"> </el-table-column>					
					<el-table-column prop="studentName" label="姓名" width="50" align="center">
					</el-table-column>
					<el-table-column prop="studentCode" label="学号" align="center">						
					</el-table-column>
					<el-table-column prop="sex" label="性别" align="center">
					</el-table-column>
					<el-table-column prop="gradeName" label="班级"  align="center">
					</el-table-column>
					<el-table-column prop="className" label="年级" align="center">
					</el-table-column>

				</el-table>
			</el-col>
			<el-col :span="2" style="width: 7.33333%;text-align:center;">
				<div>
					<img src="../../../static/images/bathocco/ruzhu.png" style="margin-top:180px;">
					<p>迁入</P>
				</div>
			</el-col>
			<el-col :span="12" style="width:46.83333%;padding:0;border:1px dashed #cccccc; height: 570px;overflow: auto;">
				<el-form :inline="true" class="demo-form-inline" :model="formData">
					<el-form-item label="楼栋:" style="width:33%">
					<el-select v-model="formData.floor" placeholder="请选择" style="width:90px">
							<el-option v-for="item in floorList" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>

					</el-form-item>

					<el-form-item label="楼层:" style="width:33%">
						<el-select v-model="formData.floor" placeholder="请选择" style="width:90px">
							<el-option v-for="item in floorList" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="宿舍号:" style="width:31%">
						<el-input v-model="formData.domitoryCode" placeholder="宿舍号" style="width: 80px"></el-input>
					</el-form-item>
				</el-form>
				<div style="text-align:center;">
				    <el-table border stripe :data="tableData" header-row-class-name="table-header" fit>
					<el-table-column type="selection" width="40" align="center"> </el-table-column>
					<el-table-column prop="order" label="序号" width="45" align="center">
					</el-table-column>
					<el-table-column prop="name" label="姓名" width="50" align="center">
					</el-table-column>
					<el-table-column prop="studentCode" label="学号" align="center">
						<span class="studentname" slot-scope="scope" @click="studentInfoDialog(scope.row.studentID)">{{scope.row.studentCode}}</span>
					</el-table-column>
					<el-table-column prop="genderName" label="系部" align="center">
					</el-table-column>
					<el-table-column prop="genderName" label="年级" width="60" align="center">
					</el-table-column>
					<el-table-column prop="cName" label="班级" align="center">
					</el-table-column>

				</el-table>
					<div style='clear:both;'></div>
					<div class="form-opres" >
				<el-button @click="submitForm" type="primary" class="u-btn">确定</el-button>
				<el-button @click="back" class="u-btn">返回</el-button>
			</div>
				</div>
			</el-col>
		</el-row>

	</div>

</template>

<script>
	export default {
		name: 'BackToTop',
		props: {
			selectiondata: {
				type: Array,
				default: function () {
					return []
				}
			},
		},
		data() {
			return {
				value: 3,
				lingvalue: 0,
				autoform: {
					sex: '',
					type: [],
					ld: ''
				},
				deptProps: {
					label: 'deptName',
					children: 'zones',
					isLeaf: 'leaf'
				}, // 部门数据
				buildingUnitSelectShow: false,
				formData: {
					deptName: "", // 部门
					deptValue: "",
					buildingUnitId: "", // 楼栋
					buildingUnitName: "",
					domitoryCode: "", // 宿舍号
					studentName: "", // 学生姓名
					studentCode: "", // 学号
					startDate: "", // 开始时间
					endDate: "", // 结束时间
					floorId: "", // 楼层
					attendanceStatusValue: "" //考勤状态码,
				},
				building:[],
				floorList: [{
					value: '0',
					label: '一楼'
				}, {
					value: '1',
					label: '二楼'
				}, {
					value: '2',
					label: '三楼'
				}, {
					value: '3',
					label: '四楼'
				}],
				tableData: []
			}
		},
		mounted() {

		},
		methods: {
			// 获取树节点
			getTreeChildNode(node, resolve) {
				if(node.level === 0) {
					return resolve([{
						deptName: '惟楚有才',
						deptId: 0
					}]);
				}
				if(node.level > 1) return resolve([]);

				setTimeout(() => {
					const data = [{
						deptName: '一班',
						deptId: '01',
						leaf: true
					}, {
						deptName: '二班',
						deptId: '02',
					}];

					resolve(data);
				}, 500);
			},
			handleNodeClick(data, Node) {
				this.formData.deptValue = data.deptName;
				this.formData.detpName = data.deptId;
				// 关闭选择器
				this.isShowSelect = false;
			},
			Select() {

			},
			back() {

			},
			submitForm() {
				console.log(this.$parent)

			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	.autops {
		.el-checkbox+.el-checkbox {
			margin-left: 0px;
		}
		.ruzhusushe {
			min-height: 468px;
			li {
				text-align: center;
				width: 102px;
				height: 102px;
				position: relative;
				float: left;
				margin: 0 23px 30px 23px;
				cursor: pointer;
				p {
					padding: 0;
					margin: 0;
					font-size: 12px;
				}
				.sushehao {
					position: absolute;
					color: white;
					font-size: 12px;
					top: 43px;
					left: 36px;
					z-index: 500;
				}
				.limask {
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					background: black;
					opacity: .2;
					z-index: 501;
				}
				.badgeimage {
					margin-top: 5px;
				}
				.selected {
					position: absolute;
					margin-top: -24px;
					top: 50%;
					left: 50%;
					margin-left: -24px;
					z-index: 502;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Accommodation/index.vue